const SERVER_UNAVAILABLE_MESSAGE = 'Сервер временно недоступен. Попробуйте через минуту.';
const TOO_MANY_REQUESTS_MESSAGE = 'Слишком много попыток. Попробуйте чуть позже.';
const NETWORK_ERROR_MESSAGE = 'Нет связи с сервером. Проверьте подключение к интернету.';

// Унифицированный парсер текста ошибки из axios-ошибок и наших ответов FastAPI
export function extractErrorMessage(err) {
  const status = err?.response?.status;
  const data = err?.response?.data;

  // Лимит запросов: бэк отвечает английским текстом
  if (status === 429) return TOO_MANY_REQUESTS_MESSAGE;

  // Новый формат от бэка: {"error": { message, status, endpoint, source }}
  if (data?.error?.message) return data.error.message;

  // Старые/переходные варианты. Ошибки iiko: русское пояснение, ниже исходный текст iiko для поддержки
  if (data?.detail?.message) {
    const { message, iiko_text: iikoText } = data.detail;
    return iikoText && iikoText !== message ? `${message}\n${iikoText}` : message;
  }
  if (typeof data?.detail === 'string') return data.detail;

  // Иногда бэк может вернуть plain text. HTML — это страница ошибки прокси (502 и т.п.),
  // её не показываем пользователю
  if (typeof data === 'string' && data.trim() && !data.trim().startsWith('<')) return data;

  // Сервис не ответил (502/503/504 от nginx) или упал без понятного сообщения
  if (status >= 500) return SERVER_UNAVAILABLE_MESSAGE;

  // Запрос ушёл, но ответа нет: сеть, CORS, таймаут
  if (err?.request && !err?.response) return NETWORK_ERROR_MESSAGE;

  // Запасной вариант
  return err?.message || 'Неизвестная ошибка';
}

// У учётной записи iiko нет прав на отчёты (iiko RMS ответил 403, бэкенд: iiko_permission_denied) —
// не сбой, а настройка прав: экраны показывают мягкую карточку NoReportAccess вместо красной ошибки
export const isReportAccessDenied = (err) => err?.response?.data?.detail?.code === 'iiko_permission_denied';
